module.exports = __webpack_public_path__ + "img/sesame.f46cd26b.svg";